import { render, staticRenderFns } from "./UserCompaniesFilter.vue?vue&type=template&id=fb86afb8&scoped=true&"
import script from "./UserCompaniesFilter.vue?vue&type=script&lang=js&"
export * from "./UserCompaniesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb86afb8",
  null
  
)

export default component.exports